import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardOfferTemplate } from 'components/Templates'

const PointCardOfferCreate: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = /^\/point_card\/offer\/(?!create$)[^/]+$/.test(pathname)

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'特典'} title={'特典'}>
      <PointCardOfferTemplate isEdit={isEdit} />
    </Layout>
  )
}

export default PointCardOfferCreate
